import classNames from 'classnames';
import { FC } from 'react';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';
import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';
import { ChatMessage } from 'APP/store/Messages/Message/ChatMessage/ChatMessage';

import styles from './VideoPayload.styles.m.css';

interface IVideoPayloadProps {
  titleClassName?: string;
  textClassName?: string;
  iconClassName?: string;
  message: ChatMessage;
  title: string;
  preventInteraction?: boolean;
  onClick(): void;
}

export const VideoPayload: FC<IVideoPayloadProps> = ({
  titleClassName,
  textClassName,
  iconClassName,
  message,
  title,
  onClick,
}) => {
  const { typeDescription, previewUrl, graphicSize, comment, preventInteraction } = message.payload;

  return (
    <MiniatureMessageLayout
      isVideo
      titleClassName={titleClassName}
      textClassName={textClassName}
      iconClassName={iconClassName}
      imageUrl={previewUrl}
      graphicSize={graphicSize}
      title={title}
      text={typeDescription}
      messageId={message.id}
      onClick={onClick}
      preventInteraction={preventInteraction}
    >
      {comment && (
        <TextRenderer
          isPlainText
          className={classNames(styles.text, textClassName)}
        >
          {comment}
        </TextRenderer>
      )}
    </MiniatureMessageLayout>
  );
};
